export default __webpack_public_path__ + "images/51dfa99f9dd7ad7591fd5343b7253e8a-shintoism.webp";